// extracted by mini-css-extract-plugin
export var cardBody = "resource-module--cardBody--1bcf3";
export var ebookGradient = "resource-module--ebookGradient--49807";
export var reportGradient = "resource-module--reportGradient--e3ee7";
export var resourceCard = "resource-module--resourceCard--d4368";
export var resourceCardButton = "resource-module--resourceCardButton--c4c42";
export var resourceTypeSpecific = "resource-module--resourceTypeSpecific--f0a18";
export var videoGradient = "resource-module--videoGradient--5b187";
export var webinarConnectGradient = "resource-module--webinarConnectGradient--706c2";
export var webinarGradient = "resource-module--webinarGradient--6f16f";